'use client';

import { LinkedIconProps } from 'libs/contentful/types';
import { pascalToSnake } from 'utils/formatters';
import Link from '../Link/Link';
import { datadogRum } from '@datadog/browser-rum-slim';
import { LabelPlacement } from 'types/constants';
import { cn } from 'utils/styles';
import { getIconByKey } from 'utils/iconRegistry';

const LinkedIcon = ({ iconName, url, showLabel, label, labelPlacement }: LinkedIconProps) => {
  const hideLabel = !showLabel || labelPlacement === LabelPlacement.Hidden; // showLabel to be deprecated
  const realIconName = pascalToSnake(iconName);

  const Icon = getIconByKey(realIconName);

  if (!Icon) {
    datadogRum.addError(`LinkedIcon Error: ${realIconName} is not a valid Icon.`);
  }

  return (
    <Link href={url} className={cn(labelPlacement === LabelPlacement.Top && 'flex flex-col-reverse items-center')}>
      {Icon && <Icon data-testid="linkedIcon" />}
      <span className={hideLabel ? 'sr-only' : 'font-sans font-medium'}>{label}</span>
    </Link>
  );
};

export default LinkedIcon;
